import { render, staticRenderFns } from "./CurrencySelect.vue?vue&type=template&id=6aa45506&scoped=true&"
import script from "./CurrencySelect.vue?vue&type=script&lang=js&"
export * from "./CurrencySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa45506",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aa45506')) {
      api.createRecord('6aa45506', component.options)
    } else {
      api.reload('6aa45506', component.options)
    }
    module.hot.accept("./CurrencySelect.vue?vue&type=template&id=6aa45506&scoped=true&", function () {
      api.rerender('6aa45506', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomInputComponents/CurrencySelect.vue"
export default component.exports